<template>
  <div>
    <h1>Assignments</h1>
    <div v-if="!assignments_list">
      <h4>Retrieving assignments list...</h4>
    </div>
    <div v-else-if="assignments_list.length == 0">
      <h4>There are no assignments yet.</h4>
    </div>
    <div v-else>
      <table class="unlined-table">
        <tr v-for="assignment in assignments_list" v-bind:key="assignment.name">
          <template v-if="assignment.file">
            <td>
              <router-link :to="'../writeup/project/' + assignment.file">{{ assignment.name }}</router-link>
            </td>
          </template>
          <template v-else>
            <td>
              <a :href="assignment.link" target="_blank">{{ assignment.name }}</a>
            </td>
          </template>
          <td>Due {{ assignment.due }}</td>
        </tr>
      </table>
    </div>
    <h2>Instructions</h2>
    <h3>APTs</h3>
    <p>APTs are automatically graded when you <b>Submit</b> your code on the
    <a href="https://bartik.mines.edu/" target="_blank">APT website</a>. There is no need to
    do anything further. You can check your raw scores on the
    <a href="https://bartik.mines.edu/" target="_blank">APT website</a> to make sure you've
    submitted everything.
    <b>Note:</b> the <a href="https://bartik.mines.edu/" target="_blank">APT website</a> lives behind
    the Mines firewall; this means if you are outside the Mines network (e.g., working from home), you
    will be unable to see the problem descriptions or submit a solution to the server unless you go
    through the campus VPN (see
    <a href="https://www.mines.edu/ccit/software-title/vpn/" target="_blank">https://www.mines.edu/ccit/software-title/vpn/</a>
    for software and instructions). </p>

    <h3>Projects</h3>
    <p>Project work should be turned in via
      <a href="https://elearning.mines.edu/login/saml" target="_blank">Canvas</a>.
      Submit your solution as one .zip file. Multiple submissions are allowed, but only the most recent
      one will be graded.</p>

    <p><b>README:</b> All project submissions should include a README file in <b>plain text</b> which
    includes the following information:</p>
    <ol>
        <li>Your name</li>
        <li>The names of anyone who assisted you on this project, including the instructor</li>
        <li>How long the project took you to complete (an estimate is fine!)</li>
        <li>Any other notes about the project, such as resources you found helpful or not helpful in
          completing the assignment, anything interesting you did in your solution, etc.</li>
    </ol>
    <p><b>Style:</b> For this course, it is more important to follow <em>some</em> style than a 
    particular style.  It is sometimes easiest to emulate the style used in the starter code for a project, or example code from the textbook or lecture slides.  Do your best to be consistent, and develop your own personal style!</p>

    <p><b>All assignments will be due at 11:59 pm on the due date.</b></p>
  </div>
</template>

<script>
import axios from 'axios'
export default {
  name: 'Assignments',
  data() {
    return {
      assignments_list: null
    }
  },
  mounted() {
    axios.get("manifests/assignments.json")
      .then(response => {
        this.assignments_list = response.data;
      });
  }
};
</script>
